export const SEARCH_NAV = 'Search';
export const PROJECTS_NAV = 'Projects';
export const WEBINARS_NAV = 'Webinars';

export const ADMIN_NAV = 'Admin';
export const SALES_NAV = 'Sales';
export const MARKETING_NAV = 'Marketing';
export const ACCOUNTING_NAV = 'Accounting';
export const HOME_NAV = 'Home';
